import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { fetchReview } from '../../redux/thunks';
import { loaderSelector, reviewHeaderSelector } from '../../redux/selector';
import ReviewHeaderUI from '../../../../../stories/components/cars/reviewpage/ReviewHeader/ReviewHeaderUI';
import HeaderNavigationUI from '../../../../../stories/components/cars/reviewpage/HeaderNavigation/HeaderNavigationUI';
import { pageView } from '../../../../config/ga';
import { scrollToTop } from '../../../../config/utils';
import { fetchPageMakerAPIs } from '../../../../common/redux/thunks';
import { gcBookingReviewScreen, getLoadedComponent } from '../../../../../shared/config/omni';
import { getTravellerInformation } from '../../../Homepage/redux/thunks';

const ReviewHeader = () => {
  const dispatch = useDispatch();
  const loaders = useSelector(loaderSelector);
  const reviewHeader =  useSelector(reviewHeaderSelector);
  const { review = false } = loaders;
  const data = review ? {} : reviewHeader;

  useEffect(() => {
    dispatch(getTravellerInformation())
    dispatch(fetchReview()).then(() => {
      getLoadedComponent('ReviewHeader')
      setTimeout(() => {
        dispatch(pageView(gcBookingReviewScreen));
      }, 2000)
    });

    scrollToTop(0, false);
    dispatch(fetchPageMakerAPIs({ isTemplates: 'cabs_dweb_review' }));
  }, []);
  
  return (
    <>
      <HeaderNavigationUI />
      <ReviewHeaderUI {...data} />
    </>
  );
}

export default ReviewHeader;